<div class="desktop">
  <div class="card mensaje">
    <div class="card-body">
      <div class="container">
        <div class="row messageRow">
          <div class="col-sm-1 d-flex align-items-center iconContainer">
            <div class="linea"></div>
            <img
              class="iconoinformacionCard"
              src="./assets/img/IconoMensaje.png"
              alt="seguro de moto precio" 
            />
          </div>
          <div class="col">
            <div>
              <span class="proceso"
                >Este seguro es voluntario y complementa al SOAT.</span
              >
              Si lo que deseas comprar es el SOAT, ingresa a
              <a
                href="https://www.sura.co/seguros/personas/movilidad/soat"
                target="_blank"
                >SURA.CO</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modile">
  <div class="card mensaje">
    <div class="card-body">
      <div class="container">
        <div class="row messageRow">
            <div class="col-sm-1 d-flex align-items-center iconContainer">
                <div class="linea"></div>
                <img
                  class="iconoinformacionCard"
                  src="./assets/img/IconoMensaje.png"
                  alt="seguro de moto precio" 
                />
              </div>
          <div class="col">
            <div>
              <span class="proceso"
                >Este seguro es voluntario y complementa al SOAT.</span
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div style="padding-top: 5px" style="text-align: start">
              Si lo que deseas comprar es el SOAT, ingresa a
              <a
                href="https://www.sura.co/web/seguros/personas/movilidad/soat"
                target="_blank"
                >SURA.CO</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
